<template>
  <div id="api-keys">
    <div class="intro-wrapper">
      <div class="content">
        <h2>{{ $t("settings.apikeys.title") }}</h2>
        <p class="description text-muted">
          {{ $t("settings.apikeys.message") }}
        </p>
        <button class="btn btn-primary-outline " @click="addApiKey(scopes)">
          <i class="fa-light fa-plus"></i> 
          {{ $t("api-key.api-key-add-btn") }}
        </button>
      </div>
    </div>
    <div class="api-keys-list-wrapper">
      <ApiKeysList :apiKeys="apiKeys" :class="{ 'loading-view': loadingApiKeys }" />
    </div>
  </div>
</template>

<script>
import AddApi from "@/components/modals/AddApi";
import ApiKeysList from "@/components/ApiKeysList";

export default {
  data() {
    return {
      error: false,
      loading: false,
      succes: false,
      loadingApiKeys: false
    };
  },
  computed: {
    apiKeys() {
      return this.$store.state.apiKeys;
    },
    scopes() {
      return this.$store.state.scopes;
    }
  },
  methods: {
    addApiKey() {
      this.$modal.show(
        AddApi,
        {
          scopes: this.$store.state.scopes,
          title: "Create API",
          onSave: (apiKey) => {
            this.loading = true;
            apiKey = JSON.stringify(apiKey);
            this.$store
              .dispatch("addApi", apiKey)
              .then(() => {
                this.showNotice();
              })
              .catch((error) => {
                this.error = true;
                console.log(error);
              });
          }
        },
        { width: 310, height: "auto", adaptive: true }
      );
    }
  },
  mounted() {
    this.loadingApiKeys = true;
    Promise.all([this.$store.dispatch("getApiKeys"), this.$store.dispatch("getScopes")]).finally(() => {
      this.loadingApiKeys = false;
    });
  },
  components: {
    ApiKeysList
  }
};
</script>

<style lang="less">
#settings #api-keys.settings-area {
  padding-bottom: 24px;
}
@media screen and (min-width: 920px) {
  #api-keys {
    display: grid;
    grid-template-columns: 3fr 7fr;
    gap: 42px;
    justify-content: space-between;

    .api-keys-list-wrapper {
      display: flex;
      justify-content: flex-end;
      flex-grow: 1;
    }
  }
}
</style>
